import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { buttonsTheme, THEME_UI_DEFAULT_KEY } from '@costar/theme-ui';

var fodal = {
  modal: {
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingTop: '44px',
    overflow: 'auto'
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  },
  pane: {
    variant: 'modal.cosmos',
    width: '98%'
  },
  card: {
    card: {
      variant: 'cards.card-modal-custom.card'
    },
    header: {
      variant: 'cards.card-modal-custom.header',
      p: 'sm'
    },
    title: {
      variant: 'cards.card-modal-custom.title',
      fontSize: '18px',
      fontWeight: '600',
      color: 'rgb(81, 81, 81)'
    }
  },
  navigation: {
    title: {
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '14px',
      color: '#515151',
      marginRight: '15px'
    },
    button: function button(_t, props) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var baseTheme = buttonsTheme['ghost'][THEME_UI_DEFAULT_KEY](_t, props);
      return _objectSpread2(_objectSpread2({}, baseTheme), {}, {
        boxShadow: 'none',
        marginLeft: '15px',
        marginRight: '15px',
        color: 'primaries.3'
      });
    }
  },
  button: function button(_t, props) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var baseTheme = buttonsTheme['ghost'][THEME_UI_DEFAULT_KEY](_t, props);
    return _objectSpread2(_objectSpread2({}, baseTheme), {}, {
      boxShadow: 'none',
      marginLeft: '15px',
      color: 'neutral.dark'
    });
  }
};

export { fodal };
//# sourceMappingURL=fodals.esm.js.map
